import React, { useState } from 'react';
import { Stream } from '../../Models/Stream';
import { useNavigate, useLocation } from "react-router-dom";
import {
  Typography,
  Card,
  CardContent,
  CardActionArea,
  CardMedia,
  Button,
  Box,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import Moment from 'moment';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import { Star, StarBorder } from '@mui/icons-material';
import ElectricBoltIcon from '@mui/icons-material/ElectricBolt';
import { useAPIContext } from '../../Context/APIContext';

const useStyles = makeStyles({
  card: {
    borderRadius: '5px !important',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
    transition: 'box-shadow 0.2s ease !important',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    width: '100%',
    height: '270px', // FIXED HEIGHT for consistency
    '&:hover': {
      boxShadow: '0 6px 12px rgba(0, 0, 0, 0.3)',
    },
  },
  media: {
    height: 140,
  },
  content: {
    textAlign: 'center',
  },
  streamName: {
    height: '4rem',
    overflowY: 'hidden',
    color: '#333',
    textAlign: 'left',
  },
  infoSection: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: '8px',
  },
  dateAdded: {
    display: 'flex',
    alignItems: 'center',
    textAlign: 'left',
    marginRight: '0.5em'
  },
  saveButton: {
    //color: '#f50057 !important',
  },
});

interface VideoCardProps {
  stream: Stream;
  saved: boolean;
  goBackUrl: string;
}

export default function VideoCard({ stream, saved, goBackUrl }: VideoCardProps) {
  const navigate = useNavigate();
  const classes = useStyles();
  const [isSaved, setIsSaved] = useState(saved);
  const { state } = useLocation();
  const { apiFetch } = useAPIContext();

  const NavigateToStream = (stream: Stream) => {
    navigate(`/stream/${stream.id}`, { state: { ...state, ViewStreamGoBackUrl: goBackUrl } });
  };

  const SaveStream = async (event: React.MouseEvent) => {
    event.stopPropagation();
    const response = await apiFetch<number>(`Users/SavedStreams`, 'POST', stream.id);
    if (response && response > 0) {
      setIsSaved(true);
    }
  };

  const UnfavouriteStream = async (event: React.MouseEvent) => {
    event.stopPropagation();
    const response = await apiFetch<number>(`Users/SavedStreams`, 'DELETE', stream.id);

    if (response && response > 0) {
      setIsSaved(false);
    }
  };

  return (
    <Card className={classes.card} key={stream.id}>
      <CardActionArea onClick={() => NavigateToStream(stream)}>
        <CardMedia
          component="img"
          className={classes.media}
          src={`https://streams.bitmovin.com/${stream.bitmovinId}/poster`}
          alt={stream.title}
        />
        <CardContent className={classes.content}>
          <Typography gutterBottom variant="body2" component="div" className={classes.streamName}>
            {stream.title}
          </Typography>
          <div className={classes.infoSection}>
            <div className={classes.dateAdded}>
              <AccessTimeIcon fontSize="small" />
              <span style={{ marginLeft: '4px' }}>{Moment(stream.dateAdded).format('DD-MMM-YYYY')}</span>
            </div>

              <Box 
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  backgroundColor: '#f0f4f0', // Light background to make points stand out
                  borderRadius: '5px',         // Rounded corners
                  padding: '4px 4px',         // Padding inside the box
                  color: '#66bb6a',            // Use the green color for the points
                  fontWeight: 'bold',          // Make the text bold
                  //boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)' // Subtle shadow
                  
                }}
              >
                <ElectricBoltIcon sx={{ color: '#66bb6a', marginRight: '4px' }} />
                {stream?.points}
              </Box>
            <Button
              size="small"
              className={classes.saveButton}
              startIcon={isSaved ? <Star /> : <StarBorder />}
              onClick={isSaved ? UnfavouriteStream : SaveStream}
            >
              {isSaved ? 'Saved' : 'Save'}
            </Button>
          </div>
        </CardContent>
      </CardActionArea>
    </Card>
  );
}
